@if (data && helptexts && informations) {
  <div>
    @for (datum of data; track datum) {
      <app-form
        [informations]="informations"
        [data]="datum"
        [helptexts]="helptexts[0]"
        (dataSubmitted)="onData($event)"
      ></app-form>
    }
    <button mat-raised-button color="accent" (click)="addGrievance()" i18n="add grievance@@add_grievance">Add Grievance</button>
    @for (grievance of grievances; track grievance) {
      <app-form
        [informations]="grievanceInformations"
        [data]="grievance"
        [helptexts]="helptexts[0]"
        [showDelete]="true"
        (deleted)="deleteGrievance($event)"
        (dataSubmitted)="onGrievanceData($event)"
      ></app-form>
    }
  </div>
}
